import React, { useState } from "react";
import classNames from "classnames";
import { clearAuthData, getUserData } from "../auth";
import PendingOrder from "./oders/PendingOrder";
import ProcessedOrderClient from "./oders/ProcessedOrderClient";
 

import FailedOrders from "./oders/FailedOrders";
import SuccessfulOrder from "./oders/SuccefullOrder";
import { useNavigate } from "react-router-dom";

// MUI Icons
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { LogoutOutlined } from "@mui/icons-material";
 
 import TaskAltIcon from '@mui/icons-material/TaskAlt'; // ✅ Success-specific icon
 
 import { orange, blue, red, green, purple, teal } from '@mui/material/colors';
 import HomeIcon from '@mui/icons-material/Home';
import DashboardIcon from '@mui/icons-material/Dashboard';
const OrderViewAmazonCustomer = () => {
  
  const userData = getUserData();
  const roles = userData?.role || [];
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("processedOrderClient");
  const [isSidebarActive, setIsSidebarActive] = useState(false);

  const userHave = roles.some(role =>
    ["ROLE_ADMIN", "ROLE_CUSTOMER"].includes(role)
  );

  const handleLogout = () => {
    clearAuthData();
    navigate("/account");
  };

  const tabsOld = [
    {
      id: "PendingOrder",
      label: "Pending Order",
      icon: <PendingActionsIcon sx={{ marginRight: 1 }} />,
      component: <PendingOrder />,
      condition: userHave,
    },
    {
      id: "processedOrderClient",
      label: "Processed Orders",
      icon: <CheckCircleIcon sx={{ color: green[500], marginRight: 1 }}/>,
      component: <ProcessedOrderClient />,
      condition: userHave,
    },
    {
      id: "FailedOrder",
      label: "Failed Order",
      icon: <CancelIcon sx={{ color: red[500], marginRight: 1 }} />,
      component: <FailedOrders />,
      condition: userHave,
    },
    {
      id: "SuccessfulOrder",
      label: "Successful Order",
      icon: <CheckCircleIcon sx={{ color: green[500], marginRight: 1 }}/>,
      component: <ProcessedOrderClient />,
      component: <SuccessfulOrder />,
      condition: userHave,
    },
    {
      id: "Logout",
      label: "Logout",
      icon: <LogoutOutlined sx={{ marginRight: 1 }} />,
      component: null,
      condition: true,
      action: handleLogout,
    },
  ];
  const tabs = [
    {
      id: "processedOrderClient",
      label: "Processed Orders",
      icon: <CheckCircleIcon sx={{ color: blue[500], marginRight: 1 }} />, // 🔵 Blue for processed
      component: <ProcessedOrderClient />,
      condition: userHave,
    },
    {
      id: "PendingOrder",
      label: "Pending Order",
      icon: <PendingActionsIcon sx={{ color: orange[500], marginRight: 1 }} />, // ⏳ Orange for pending
      component: <PendingOrder />,
      condition: userHave,
    },
    {
      id: "FailedOrder",
      label: "Failed Order",
      icon: <CancelIcon sx={{ color: red[500], marginRight: 1 }} />, // ❌ Red for failed
      component: <FailedOrders />,
      condition: userHave,
    },
    {
      id: "SuccessfulOrder",
      label: "Successful Order",
      icon: <TaskAltIcon sx={{ color: green[500], marginRight: 1 }} />, // ✅ Green for success
      component: <SuccessfulOrder />,
      condition: userHave,
    },
    {
            id: "Home",
            label: "Home",
            icon: <HomeIcon sx={{ color: purple[500], marginRight: 1 }} />, // 🏠 Purple for Home
            component: null,
            condition: true,
            action: () => navigate('/'),
          },
          {
            id: "Dashboard",
            label: "Dashboard",
            icon: <DashboardIcon sx={{ color: teal[500], marginRight: 1 }} />, // 📊 Teal for Dashboard
            component: null,
            condition: true,
            action: () => navigate('/dashboard-customer'),
            condition:userHave,
          },
    {
      id: "Logout",
      label: "Logout",
      icon: <LogoutOutlined sx={{ color: red[400], marginRight: 1 }} />, // 🚪 Red for logout
      component: null,
      condition: true,
      action: handleLogout,
    },
  ];
  
  const handleTabClick = (tab) => {
    if (tab.action) {
      tab.action();
    } else {
      setActiveTab(tab.id);
      setIsSidebarActive(false);
    }
  };
  

  const sidebarController = () => setIsSidebarActive(!isSidebarActive);

  return (
    <section className="contact py-80">
      <div className={`side-overlay ${isSidebarActive && "show"}`} onClick={sidebarController}></div>
      <div className="container container-lg">
        <div className="row">
          {/* Sidebar */}
          <div className="col-lg-3">
            <div className={`shop-sidebar ${isSidebarActive && "active"}`}>
              <button
                onClick={sidebarController}
                type="button"
                className="shop-sidebar__close d-lg-none d-flex w-32 h-32 flex-center border border-gray-100 rounded-circle hover-bg-main-600 position-absolute inset-inline-end-0 me-10 mt-8 hover-text-white hover-border-main-600"
              >
                <CloseIcon />
              </button>
              <div className="shop-sidebar__box border border-gray-100 rounded-8 p-32 mb-32">
                <h6 className="text-xl border-bottom border-gray-100 pb-24 mb-24 flex items-center gap-2">
                  Orders Management
                </h6>
                <ul className="max-h-540 overflow-y-auto scroll-sm">
                  {tabs.filter(tab => tab.condition).map(tab => (
                    <li className="mb-24" key={tab.id}>
                      <a
                        href={`#${tab.id}`}
                        className={classNames("text-gray-900 hover-text-main-600 flex-align gap-8", {
                          "text-main-600 font-semibold": activeTab === tab.id
                        })}
                        onClick={(e) => {
                          e.preventDefault();
                          handleTabClick(tab);
                        }}
                        style={{
                          outline: activeTab === tab.id ? '2px solid #EF6036' : 'none',
                          outlineOffset: '2px',
                        }}
                      >
                        {tab.icon} {tab.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="col-lg-9">
            {/* Mobile Toggle */}
            <div className="d-lg-none d-block mb-40">
              <button
                onClick={sidebarController}
                type="button"
                className="w-44 h-44 flex-center border border-gray-100 rounded-6 text-2xl sidebar-btn"
              >
                {isSidebarActive ? <CloseIcon /> : <MenuIcon />}
              </button>
            </div>

   {/* Main Content */}
            <div className="tab-content">
              {tabs.map(
                (tab) =>
                  tab.condition &&
                  tab.component && (
                    <div
                      key={tab.id}
                      className={classNames("tab-pane fade", {
                        "show active": activeTab === tab.id,
                      })}
                      id={tab.id}
                      role="tabpanel"
                    >
                      {tab.component}
                    </div>
                  )
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OrderViewAmazonCustomer;
